<ng-container *ngIf="report$ | async as report; else loadingTpl">
  <app-analysis-header>
    <gpt-router-back
      [url]="type == AnalysesTypesLowercase.DNA ? 'dna' : 'blood'"
    ></gpt-router-back>

    <app-analysis-header-title>
      <h4 class="h4-bold">
        {{ type === AnalysesTypesLowercase.Blood ? report.name : report.title }}
      </h4>
    </app-analysis-header-title>
    <app-analysis-header-subtitle *ngIf="type !== AnalysesTypesLowercase.DNA">
      <p class="p4-regular text-secondary">
        {{ report.generated | localDate }}
      </p>
    </app-analysis-header-subtitle>
  </app-analysis-header>

  <div class="container">
    <ng-container
      *ngIf="type == AnalysesTypesLowercase.DNA; else nonDnaResults"
    >
      <ng-container *ngIf="analyses$ | async as analyses; else loadingTpl">
        <app-new-analyses-list
          [analyses]="analyses"
          [type]="type"
        ></app-new-analyses-list>
        <div *ngFor="let analysis of analyses" class="gmb-12">
          <app-analysis-link
            *ngIf="!analysis?.isNew"
            [analysis]="analysis"
            [type]="type"
          ></app-analysis-link>
        </div>
      </ng-container>
    </ng-container>
    <ng-template #nonDnaResults>
      <div *ngFor="let analysis of report.analyses" class="gmb-12">
        <app-analysis-link
          [analysis]="analysis"
          [type]="AnalysesTypesLowercase.Blood"
        ></app-analysis-link>
      </div>
    </ng-template>

    <!-- <ng-container *ngIf="recommendations$ | async as recommendations else loadingTpl">

      <ng-container *ngIf="recommendations.length > 0 && report.status == 'completed'">
        <h4 class="mt-5 mb-0">{{ 'RECOMMENDATIONS.TITLE' | translate }}</h4>
        <p class="mt-0 mb-3 text-secondary text-uppercase">{{ 'RESULTS.ID.BASED' | translate }}</p>

        <div class="row mb-3" *ngFor="let recommendation of recommendations">
          <div class="col-12 col-lg-6">
            <div class="card shadow">
              <img [src]="recommendation.image" class="card-img" alt="..." />

              <div class="card-body">
                <p class="my-0 text-secondary text-uppercase">{{ recommendation.type }}</p>
                <h3>{{ recommendation.title }}</h3>

                <p class="mt-4">{{ recommendation.description }}</p>
              </div>

              <div class="card-footer bg-white">
                <a routerLink="/recommendations/{{recommendation.id}}" class="gbtn-1 btn-block text-primary">{{ 'RESULTS.ID.MORE' | translate }}</a>
              </div>
            </div>
          </div>

          <div class="col-12 col-lg-6">
            <div class="card shadow">
              <h3 class="card-header bg-white">
                {{ 'RESULTS.ID.OPTIMAL_DAY' | translate }}
              </h3>
              <div class="card-body">
                <div class="form-group">
                  <label for="select" class="text-secondary">{{ 'RESULTS.ID.ACTIVITY' | translate }}</label>
                  <select class="form-control" #select>
                    <option *ngFor="let intake of recommendation.intakes" [value]="intake.id">{{intake.name}}</option>
                  </select>

                  <ng-container *ngFor="let intake of recommendation.intakes">
                    <ng-container *ngIf="intake.id === select.value">
                      <h3 class="mt-4 mb-0">{{ intake.value }}</h3>
                      <small class="text-secondary">{{ 'RESULTS.ID.DIET' | translate }}</small>

                      <div class="list-group list-group-flush mt-3">
                        <a href="javascript:;" class="list-group-item list-group-item-action px-2" *ngFor="let nutrient of intake.nutrients">
                          <div class="row">
                            <div class="col-8 col-md-9">
                              <strong>{{ nutrient.name }}</strong>
                              <div class="progress" style="height: 6px">
                                <div class="progress-bar bg-info" [style.width.%]="nutrient.value"></div>
                              </div>
                            </div>

                            <div class="col-4 col-md-3 text-end">
                              <div class="align-middle mt-1">{{ nutrient.value }} % <i class="gpicon-forward text-muted ms-3"></i></div>
                            </div>
                          </div>
                        </a>
                      </div>

                    </ng-container>
                  </ng-container>

                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

    </ng-container> -->

    <!-- Temporary disabled consultation -->
    <!--app-consulting
      [productId]="report.productId"
      [video]="['DNA Lifestyle', 'DNA Lifestyle WGS'].includes(report.type)"
    ></app-consulting-->
  </div>
</ng-container>

<ng-template #loadingTpl>
  <div *ngIf="error" class="container my-4">
    <div class="gp-alert gp-alert-danger p3-regular">
      <span class="p3-semibold">{{ 'ERROR' | translate }}</span>
      {{ 'FAILURE.GENERAL_ERROR.CONTENT' | translate }}
    </div>
  </div>
  <gpu-loading-spinner-wrapper *ngIf="!error">
    <gpu-loading-spinner></gpu-loading-spinner>
  </gpu-loading-spinner-wrapper>
</ng-template>
